import initializeMobileMenu from './menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import './utils/scrollup';
import initializeLazyYoutube from "./utils/lazy-youtube";
import initializeHeader from "./utils/header";
import wp from "mmenu-js";
import initializeImageSlider from "./blocks/image-slider";
import initializeHomeSlider from "./blocks/home-slider";
import initializeBoxSlider from "./blocks/box-slider";
import initializeWooSidebarCategories from "./blocks/woo-sidebar-categories";
import blockLogotypes from './blocks/logotypes';
import initializeSubMunu from './woo/menu';
import initializeCheckoutNipValidation from './woo/checkout-nip-validation';
import initializeFreeShippingMessage from './blocks/free-shipping-message';

// import initializeAccordions from "./blocks/accordion";
// import initializeIconBoxes from './blocks/icon-boxes';
// import initializeNumbersBlock from './blocks/numbers';
// import initializeGallerySection from './blocks/gallery-section';
// import initializeGalleryGrid from "./blocks/gallery-grid";
// import initializeBrands from './blocks/brands';
// import initializeGallerySlider from './blocks/gallery-slider';
// import initializeGalleryText from './blocks/gallery-text';
// import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {

        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 500
            });
        });
        initializeHeader();
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeFiles();
        initializeLazyYoutube();
        initializeImageSlider();
        initializeHomeSlider();
        initializeBoxSlider();
        initializeWooSidebarCategories();
        blockLogotypes();
        initializeSubMunu();
        initializeCheckoutNipValidation();
        initializeFreeShippingMessage();
        // initializeAccordions();
        // initializeCollapse();
        // initializeIconBoxes();
        // initializeNumbersBlock();
        // initializeGallerySection();
        // initializeGalleryGrid();
        // initializeBrands();
        // initializeGallerySlider();
        // initializeGalleryText();
        // initializeIconBoxesAnimation();

         const Woo = new WooCommerce();

    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
